import { currency } from "helpers/format.js";
import "./styles.scss";

const VehicleDataItem = ({ type, style, label, text, discount }) => {
  return (
    <div className={`vehicleDataItem ${style} ${type}`}>
      <div className="label">{label}</div>
      <div className="data">
        {text}
        {discount > 0 && <span>{currency(discount)} de descuento</span>}
      </div>
    </div>
  );
};

export default VehicleDataItem;
